<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
  @import "assets/css/common.css";
  @import "element-ui/lib/theme-chalk";
</style>



// WEBPACK FOOTER //
// src/App.vue